import { useEffect } from "react";
import { idleCursorMs } from "../constants";

// Verbergt de muisaanwijzer als er idleCursorMs lang niets beweegt.
//
// De tv hangt aan een Raspberry Pi met een muis eraan: waar die aanwijzer
// blijft staan, staat hij de hele dag in beeld, vaak midden over een kaart.
// Beweeg je de muis weer, dan is hij er meteen terug - je hoeft dus niet
// blind te zoeken.
//
// De klasse gaat op body en niet op de dashboard-container: de aanwijzer
// kan ook buiten het geschaalde canvas staan (de zwarte randen), en die
// moet net zo goed verdwijnen.

const hiddenClass = "cursor-hidden";
const wakeEvents = ["mousemove", "mousedown", "wheel", "touchstart", "keydown"];

export function useIdleCursor({ delay = idleCursorMs } = {}) {
  useEffect(() => {
    if (!delay) return undefined;

    let timer = null;
    let lastX = null;
    let lastY = null;

    const hide = () => {
      timer = null;
      document.body.classList.add(hiddenClass);
    };

    const wake = () => {
      document.body.classList.remove(hiddenClass);
      clearTimeout(timer);
      timer = setTimeout(hide, delay);
    };

    // Een mousemove zonder verplaatsing telt niet als beweging: sommige
    // browsers sturen er een zodra de cursor-stijl wijzigt, en dan zou het
    // verbergen zichzelf meteen weer ongedaan maken.
    const onMove = (event) => {
      if (event.clientX === lastX && event.clientY === lastY) return;
      lastX = event.clientX;
      lastY = event.clientY;
      wake();
    };

    const onOther = () => wake();

    window.addEventListener("mousemove", onMove, { passive: true });
    wakeEvents
      .filter((name) => name !== "mousemove")
      .forEach((name) => window.addEventListener(name, onOther, { passive: true }));

    // Meteen aftellen: staat de muis al stil sinds het opstarten, dan hoeft
    // niemand hem eerst te bewegen om hem weg te krijgen.
    timer = setTimeout(hide, delay);

    return () => {
      window.removeEventListener("mousemove", onMove);
      wakeEvents
        .filter((name) => name !== "mousemove")
        .forEach((name) => window.removeEventListener(name, onOther));
      clearTimeout(timer);
      document.body.classList.remove(hiddenClass);
    };
  }, [delay]);
}
